var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.07692C9.85 1.07692 11.5885 1.79615 12.8962 3.10385C14.2038 4.41154 14.9231 6.15 14.9231 8C14.9231 9.85 14.2038 11.5885 12.8962 12.8962C11.5885 14.2038 9.85 14.9231 8 14.9231C6.15 14.9231 4.41154 14.2038 3.10385 12.8962C1.79615 11.5885 1.07692 9.85 1.07692 8C1.07692 6.15 1.79615 4.41154 3.10385 3.10385C4.41154 1.79615 6.15 1.07692 8 1.07692ZM8 0C3.58077 0 0 3.58077 0 8C0 12.4192 3.58077 16 8 16C12.4192 16 16 12.4192 16 8C16 3.58077 12.4192 0 8 0Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.4419807aaad691c35a2183e30874883f.svg";
export { ForwardRef as ReactComponent };